<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose"
  >
     <div class="table-box">
         <coententTable
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              :customSlot="customSlot"
              :pagination="false"
              :y="360"
            >
             <template v-slot:pageType="scopeVal">
                  {{scopeVal.scope.pageType == 0 ? '首页' : '其他页'}}
              </template>
               <template v-slot:type="scopeVal">
                  <span v-if="scopeVal.scope.type == 0">网页</span>
                  <span v-if="scopeVal.scope.type == 1">图片</span>
                  <span v-if="scopeVal.scope.type == 2">视频</span>
                  <span v-if="scopeVal.scope.type == 3">附件</span>
                  <span v-if="scopeVal.scope.type == 4">其他</span>
              </template>
             <template v-slot:operation="scopeVal">
                  <a @click="openPage(scopeVal.scope)" class="btnTwo">定位</a>
              </template>
            </coententTable>
            <div class="pagination" v-if="pagination.total > 0">
            <a-pagination
              :current="pagination.current"
              :pageSize="pagination.pageSize"
              :total="pagination.total"
              @change="onShowSizeChange"
              :page-size-options="pagination.pageSizeOptions"
              :show-total="(total) => `共 ${pagination.total} 条`"
            />
          </div>
     </div>
  </el-dialog>
</template>
<script >
import coententTable from "@/components/coentent_table.vue";
import {urlUsabilityInfoPageList} from '../index';
export default {
  components:{
    coententTable
  },
  data() {
    return {
       columns: [
        {
          title: "序号",
          dataIndex: "num",
          ellipsis: true,
          width:80,
        },
        {
          title: "错链地址",
          dataIndex: "errorUrl",
          ellipsis: true,
          width:400,
        },
        {
          title: "所在页面",
          dataIndex: "pageType",
          ellipsis: true,
          width:120,
          scopedSlots: { customRender: "pageType" },
        },
        {
          title: "类型",
          dataIndex: "type",
          ellipsis: true,
          width:80,
          scopedSlots: { customRender: "type" },
        },
         {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 120,
          fixed: "right",
        },
      ],
      customSlot: [
        {
          name: "pageType",
          customRender: "pageType",
        },
        {
          name: "type",
          customRender: "type",
        }
      ],
       dataSource: [],
      loading: false,
      dialogTitle:'',
       pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    itemData:{}
  },
  mounted() {
    this.getList()
    this.dialogTitle = `链接可用性错链清单（${this.itemData.time}）`
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    openPage(item){
        window.open(item.pageUrl)
    },
    getList(){
      this.loading = true;
      urlUsabilityInfoPageList({
        id:this.itemData.id,
        current:this.pagination.current,
        size:this.pagination.pageSize,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data.records;
               this.pagination.current =  res.data.current;
              this.pagination.total =  res.data.total;
              for (let index = 0; index <  this.dataSource.length; index++) {
                const element =  this.dataSource[index];
                if(this.pagination.current >= 2){
                    element.num = (index + 1 + (this.pagination.current - 1)*this.pagination.pageSize)
                }else{
                  element.num = (index + 1)
                }
              }
          }
          this.loading = false;
      })
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
       this.getList()
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
/deep/ .table{
  margin: 0px;
}
/deep/ .el-dialog__body{
  padding-top: 10px;
}
.table-box{
  position: relative;
}
.pagination {
  display: flex;
  margin-top: 20px;
  justify-content: right;
}
/deep/ .el-dialog__body{
  padding-bottom: 24px;
}
// @media screen and (max-width: 1000px) {
//     .box{
//       min-width: 900px !important;
//     }
// } 
</style>
